<template>
  <div v-if="visibleCards.length">
    <v-card
      v-for="card in visibleCards"
      :key="card.type"
      class="alert-card mb-4"
      rounded="lg"
      :style="{ borderLeft: '6px solid ' + (card.critical ? '#e53935' : '#a86400') }"
    >
      <v-card-text class="pa-5">
        <v-row align="center">
          <v-col cols="12" md="8">
            <div class="d-flex align-start mb-2">
              <v-icon size="32" :color="card.critical ? 'error darken-1' : 'warning darken-1'" class="mr-3">
                mdi-card-account-details-outline
              </v-icon>
              <div>
                <h2 class="text-subtitle-1 font-weight-bold">
                  {{ card.title }}ใกล้หมดอายุ
                </h2>
                <p class="text-caption grey--text mb-0">
                  เหลืออีก {{ card.daysLeft }} วัน — กรุณาดำเนินการต่ออายุใบอนุญาตล่วงหน้า
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="alert-actions d-flex flex-column align-md-end align-center">
              <flip-countdown
                v-if="card.expiryDate"
                :deadline="card.expiryDate + ' 00:00:00'"
                :labels="labels"
                class="countdown-timer mb-3"
              ></flip-countdown>
              <v-btn
                small
                text
                color="grey darken-1"
                :disabled="card.critical"
                @click="dismiss(card.type)"
              >
                <v-icon left small>mdi-close</v-icon>
                รับทราบแล้ว (เตือนอีกครั้งใน 7 วัน)
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

const LICENSES = [
  { type: "teacher", title: "ใบอนุญาตประกอบวิชาชีพครู", numberField: "pt_licence", ageField: "Agelicence", expiryField: "pt_enddate" },
  { type: "director", title: "ใบอนุญาตประกอบวิชาชีพผู้บริหารสถานศึกษา", numberField: "pt_licencedr", ageField: "Agelicencedr", expiryField: "pt_enddatedr" },
  { type: "supervisor", title: "ใบอนุญาตประกอบวิชาชีพศึกษานิเทศก์", numberField: "pt_licence_sp", ageField: "Agelicence_sp", expiryField: "pt_enddate_sp" }
];

// ระยะแจ้งเตือนล่วงหน้า/ขั้นวิกฤต — ดู MEMORY/plan: 180 วัน = เริ่มแจ้งเตือน, 60 วัน = ขั้นวิกฤต (บังคับแสดงเสมอ)
const WARN_DAYS = 180;
const CRITICAL_DAYS = 60;
// dismiss ไว้ได้นานสุด 7 วันก่อนกลับมาแจ้งเตือนซ้ำ (ระบบนี้ไม่มีช่องทางแจ้งเตือนส่วนบุคคลจริง เช่น อีเมล/LINE
// จึงใช้ localStorage per-browser แทน — ดูรายละเอียดในแผนที่ผู้ใช้อนุมัติแล้ว)
const RENOTIFY_DAYS = 7;

export default {
  name: "LicenseExpiryAlerts",
  components: { FlipCountdown },
  props: {
    users: { type: Object, required: true }
  },
  data() {
    return {
      labels: { days: "วัน", hours: "ชม.", minutes: "นาที", seconds: "วิ" },
      now: Date.now()
    };
  },
  computed: {
    visibleCards() {
      return LICENSES.map(l => {
        const number = this.users[l.numberField];
        const age = this.users[l.ageField];
        const daysLeft = age === null || age === undefined ? null : Number(age);
        return {
          type: l.type,
          title: l.title,
          expiryDate: this.users[l.expiryField],
          daysLeft,
          critical: daysLeft !== null && daysLeft <= CRITICAL_DAYS,
          eligible:
            !!number &&
            daysLeft !== null &&
            !Number.isNaN(daysLeft) &&
            daysLeft <= WARN_DAYS
        };
      }).filter(c => c.eligible && (c.critical || !this.isDismissed(c.type)));
    }
  },
  methods: {
    dismissKey(type) {
      return `license_alert_dismiss_${this.users.id_card}_${type}`;
    },
    isDismissed(type) {
      try {
        const dismissedAt = localStorage.getItem(this.dismissKey(type));
        if (!dismissedAt) return false;
        const daysSince = (this.now - new Date(dismissedAt).getTime()) / 86400000;
        return daysSince < RENOTIFY_DAYS;
      } catch (e) {
        return false;
      }
    },
    dismiss(type) {
      try {
        localStorage.setItem(this.dismissKey(type), new Date().toISOString());
      } catch (e) {
        // localStorage ไม่พร้อมใช้งาน (private mode ฯลฯ) — ไม่กระทบข้อมูลจริง แค่การ์ดจะกลับมาแสดงใหม่ทุกครั้ง
      }
      this.now = Date.now();
    }
  }
};
</script>

<style scoped>
.alert-card {
  transition: box-shadow 0.2s ease;
}
.countdown-timer {
  transform: scale(0.8);
  transform-origin: right center;
}
</style>
